import {
  Box,
  Grid,
  useTheme,
  Skeleton,
  Divider,
} from '@mui/material';

function OverviewSkeleton() {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          border: `${theme.spacing(0.125)} solid ${theme.palette.grey[300]}`,
          borderRadius: theme.spacing(3),
          p: theme.spacing(3),
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(1.5),
          alignItems: 'center',
        }}
      >
        <Skeleton variant="rectangular" height={100} width={100}
          sx={{
            borderRadius: theme.spacing(1),
          }}
        />
        <Skeleton animation="wave" height={theme.spacing(2.25)} sx={{ width: '40%', mb: theme.spacing(0.5) }} />
        <Skeleton animation="wave" height={theme.spacing(2.25)} sx={{ width: '70%' }} />
        <Skeleton animation="wave" height={theme.spacing(2.25)} sx={{ width: '70%' }} />
      </Box>
    </>
  );
}

function ArticlesSkeleton() {
  const theme = useTheme();
  return (
    <Box
      // key={i}
      sx={{
        p: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'left',
        border: `${theme.spacing(0.125)} solid ${theme.palette.grey[300]}`,
        borderRadius: theme.spacing(3),
      }}
    >
      <Skeleton animation="wave" height={theme.spacing(2)} sx={{
        width: '20%',
        mb: theme.spacing(1),
      }} />
      <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '70%', mb: theme.spacing(3) }} />
      <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '95%', mb: theme.spacing(1) }} />
      <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '80%' }} />
    </Box>
  );
}
function OffersSkeleton() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        p: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'left',
        border: `${theme.spacing(0.125)} solid ${theme.palette.grey[300]}`,
        borderRadius: theme.spacing(3),
      }}
    >
      <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '100%', mb: theme.spacing(0) }} />
    </Box>
  );
}

export default function PartnerLoadingSkeleton() {
  const theme = useTheme();

  return (
    <Grid container spacing={theme.spacing(4)}
      sx={{
        p: theme.spacing(4),
        pt: theme.spacing(8),
      }}
    >
      <Grid item lg={4} md={4} sm={4} xs={12}>
        <Box>
          <OverviewSkeleton />
        </Box>
        <Box sx={{ mt: theme.spacing(3) }}>
          <ArticlesSkeleton />
        </Box>
      </Grid>
      <Grid item lg={8} md={8} sm={8} xs={12}>
        <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '15%', mb: theme.spacing(1) }} />
        <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '95%', mb: theme.spacing(1) }} />
        <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '80%' }} />
        <Divider sx={{ mt: theme.spacing(4), mb: theme.spacing(6) }} />
        <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '15%', mb: theme.spacing(2) }} />
        <OffersSkeleton />
        <Divider sx={{ mt: theme.spacing(4), mb: theme.spacing(6) }} />
        <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '15%', mb: theme.spacing(2) }} />
        {[0, 1].map((i) => (
          <Box key={i}>
            <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '15%', mb: theme.spacing(1) }} />
            <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '95%', mb: theme.spacing(1) }} />
            <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '60%', mb: theme.spacing(3) }} />
          </Box>
        ))}
        <Divider sx={{ mt: theme.spacing(4), mb: theme.spacing(6) }} />
        <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '15%', mb: theme.spacing(2) }} />
        <Box
          sx={{
            display: 'grid',
            justifyContent: 'center',
            gap: theme.spacing(2),
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            mt: theme.spacing(3),
          }}
        >
          {[0, 1].map((i) => (
            <ArticlesSkeleton key={i} />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
}
